module.exports = __webpack_public_path__ + "media/svg/original_light_vertical-2af47292.svg";